import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { applyTheme, cachedChoice, pickChoice } from "./lib/theme";
import { setupViewport } from "./lib/telegram";
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "./index.css";

// Разворачиваем окно и красим шапку ДО первого рендера — иначе на старте
// видно белую полосу стандартной шапки Telegram. Тема берётся из прошлого
// запуска: ответ `/me` уточнит её, но ждать его с чёрным экраном нельзя.
setupViewport();
applyTheme(pickChoice(null, cachedChoice()));

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
